import { inject } from '@angular/core';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { ProductConfigurationConfigurable } from '../../product-configuration-configurable';
import { ProductConfigurationConfigurableProductDataService } from '../../product-data/product-configuration-configurable-product-data.service';

interface IStockEngineConfig {
    logic: NProductConfiguration.Configurable.TRuleLogic;
}

/**
 * Applies logic to values without salable product
 */
export const configurableStockCodeEngine: NProductConfiguration.Configurable.EngineGenerator<IStockEngineConfig> = (
    config: IStockEngineConfig
) => {
    const dataService = inject(ProductConfigurationConfigurableProductDataService);
    const configuration = inject(NProductConfiguration.Configuration) as ProductConfigurationConfigurable;

    return (attributeCode: string, value: number) => {
        const filter = { ...configuration.selection$.getValue() };
        filter[attributeCode] = value;
        const matchChildren = dataService.matchChildren(filter, configuration.parent$.value, []);
        if (matchChildren.children.find(i => i.isSalable())) {
            return undefined;
        }
        return config.logic === 'error' ? 'oos' : config.logic;
    };
};
